import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportListaChecklistServicoItemUseCase } from "../../../presentation/useCases/read/get_report_lista_checklist_servico_item_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportListaChecklistServicoItemUseCase
 */

export class GetReportListaChecklistServicoItemUseCase implements IGetReportListaChecklistServicoItemUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportListaChecklistServicoItem(
    requiredMimeType: ReportMimeType | null,
    idChecklistServico: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportListaChecklistServicoItem(
      requiredMimeType,
      idChecklistServico,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `checklist_servico_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
